module.exports = __webpack_public_path__ + "img/30.10abe697.jpg";